import { z } from "zod";

import {
  requiredChecked,
  requiredString,
} from "@/common/components/forms/schema";
import { PASSWORD_MIN_LENGTH } from "@/shared/constants/password.constants";

const newAccountSchema = z.object({
  email: requiredString().email("NewAccount.emailFormatError"),
  password: requiredString("NewAccount.passwordLengthError").min(
    PASSWORD_MIN_LENGTH,
    "NewAccount.passwordLengthError",
  ),
  license: requiredChecked("NewAccount.licenseCheckedError"),
});

type NewAccountFormValues = z.infer<typeof newAccountSchema>;

const NEW_ACCOUNT_INITIAL_VALUES: NewAccountFormValues = {
  email: "",
  password: "",
  license: false,
};

export {
  newAccountSchema,
  NEW_ACCOUNT_INITIAL_VALUES,
  type NewAccountFormValues,
};
